import { Icon } from "@pepperstone/pepper-ui-kit";
import { classNames } from "@repo/ui";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

type ErrorMessageProps = {
  message?: string | ReactNode;
  placeholder?: boolean;
  className?: string;
};

export const ErrorMessage = ({
  message,
  placeholder,
  className,
}: ErrorMessageProps) => {
  const { t } = useTranslation();
  return placeholder ? (
    <div
      className={classNames([
        "ps-text-body-v2-xs ps-text-text-primary-error ps-flex ps-gap-1 ps-items-center",
        className,
      ])}
    >
      {message ? (
        <>
          <Icon icon="alert-triangle" />
          <span data-testid="error_message">{message}</span>
        </>
      ) : (
        <span>&nbsp;</span>
      )}
    </div>
  ) : (
    message && (
      <div
        className={classNames([
          "ps-text-body-v2-xs ps-text-text-primary-error ps-flex ps-gap-1 ps-items-center",
          className,
        ])}
      >
        <Icon icon="alert-triangle" />
        <span data-testid="error_message">
          {typeof message === "string" ? t(message) : message}
        </span>
      </div>
    )
  );
};
